import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

const CountdownOffer = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: 29,
        hours: 14,
        minutes: 0,
        seconds: 33,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                let { days, hours, minutes, seconds } = prev;

                seconds--;
                if (seconds < 0) {
                    seconds = 59;
                    minutes--;
                }
                if (minutes < 0) {
                    minutes = 59;
                    hours--;
                }
                if (hours < 0) {
                    hours = 23;
                    days--;
                }
                if (days < 0) {
                    days = 0;
                    hours = 0;
                    minutes = 0;
                    seconds = 0;
                }

                return { days, hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatNumber = (num) => num.toString().padStart(2, "0");
    const { t } = useTranslation();

    return (
        <app-sale-promo>
            <div className="c-offer__feat row">
                <div className="col-12 col-md">
                    <figure className="o-fig-object h-100 ratio ratio-16x9">
                        <img src="https://pro-static.h10hotels.com/gallery/T11D3/31_HESPanoramicView.jpg" alt="Vista panorámica del hotel frente al mar" />
                    </figure>
                </div>
                <div className="col-12 col-md o-col-md-mw6">
                    <div className="o-counter-block">
                        <app-sale-promo-timer>
                            <div className="o-counter">
                                <div className="dias" id="a151a054-af2f-4648-9b3c-07b787712a74-days">
                                    <span>19 <span>Días</span>
                                    </span>
                                </div>
                                <div className="o-counter-sep"></div>
                                <div className="horas" id="a151a054-af2f-4648-9b3c-07b787712a74-hours">
                                    <span>12 <span>Horas</span>
                                    </span>
                                </div>
                                <div className="o-counter-sep"></div>
                                <div className="minutos" id="a151a054-af2f-4648-9b3c-07b787712a74-minuts">
                                    <span>31 <span>Minutos</span>
                                    </span>
                                </div>
                                <div className="o-counter-sep"></div>
                                <div className="segundos" id="a151a054-af2f-4648-9b3c-07b787712a74-seconds">
                                    <span>27 <span>Segundos</span>
                                    </span>
                                </div>
                            </div>
                        </app-sale-promo-timer>
                        <p>¡Reserva ya!</p>
                    </div>

                    <h3 className="text-center h6 o-title-space">
                        <p>
                            <strong>El secreto de viajar en primavera</strong>
                        </p>
                    </h3>
                    <p className="text-center h6 o-title-space text-primary">
                        <strong>Código promo: SPRING26</strong>
                    </p>

                    <div className="text-center">
                        <p>Ha llegado la primavera, el momento ideal para descubrir nuevos horizontes.</p>
                        <p>Regálate una desconexión total con el clima perfecto y disfruta de los beneficios exclusivos de reservar con H10 Hotels:</p>
                        <p>Reserva antes del 30 de abril y viaja cuando quieras con <strong> hasta un 20% de descuento</strong>. Válido para estancias hasta el 31 de diciembre de 2027. </p>
                    </div>
                    <p className="text-center text-md"> Consulta las condiciones <strong>
                        <a className="open-modal">aquí</a>. </strong>
                    </p>
                </div>
            </div>
        </app-sale-promo>
    );
}

export default CountdownOffer;
